export default __webpack_public_path__ + "static/media/success-characters.148acfcc.png";